import { FC, useState } from "react";
import QRCode from "react-qr-code";
import Lottie from "lottie-react";
import { bodyScanScreenUI } from "../../configs";
import { useTranslation } from "react-i18next";
import { font } from "../../configs";
import HelpIcon from "../../assets/icons/HelpIcon";
import { Popper, Typography, Paper, ClickAwayListener } from "@mui/material";
import { findBrandByDomain } from "../../configs/configLoader";

import "./index.css";

interface IPropsQrcodeDesktop {
  url?: string;
  loading?: boolean;
  descriptionStyles: React.CSSProperties;
}

const QrcodeDesktop: FC<IPropsQrcodeDesktop> = ({
  url,
  loading,
  descriptionStyles,
}) => {
  const { t } = useTranslation("components/qrcode/mobile");

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);
  const id = open ? "info-popper" : undefined;

  const brandDefined = findBrandByDomain();

  const isGivenchy = brandDefined?.name === "Givenchy";

  return (
    <>
      {!loading ? (
        <QRCode
          className="qrcode"
          size={220}
          value={`${url}`}
          fgColor={bodyScanScreenUI.qrcode.backgroundColor}
          viewBox={"0 0 256 256"}
          style={{ marginTop: isGivenchy ? 0 : "50px" }}
        />
      ) : (
        <Lottie
          className="qrcode_animation"
          animationData={require("../../assets/animations/qrcode_loader.json")}
        />
      )}
      <div className="help-info">
        {!isGivenchy ? <HelpIcon /> : null}
        <span
          tabIndex={0}
          className="link"
          aria-describedby={id}
          onMouseEnter={(e) => setAnchorEl(e.currentTarget)}
          onMouseLeave={() => setAnchorEl(null)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              setAnchorEl(anchorEl ? null : e.currentTarget);
              e.preventDefault();
            }
          }}
          style={{
            color: `${isGivenchy ? "#000000" : descriptionStyles.color}`,
            fontFamily: `${font}, sans-serif`,
          }}
        >
          {t("info")}
        </span>
        <Popper
          id={id}
          open={open}
          anchorEl={anchorEl}
          placement="top"
          style={{
            position: "relative",
            top: isGivenchy ? "100px" : "0px",
          }}
          modifiers={[
            {
              name: "offset",
              options: {
                offset: [isGivenchy ? -100 : 0, isGivenchy ? 100 : 0], // [x, y]
              },
            },
          ]}
        >
          <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
            <Paper
              className="popper-container"
              style={{
                border: `1px solid ${isGivenchy ? "#000000" : descriptionStyles.color}`,
                fontFamily: `${font}, sans-serif`,
              }}
            >
              <Typography
                style={{
                  color: `${isGivenchy ? "#000000" : descriptionStyles.color}`,
                  fontFamily: `${font}, sans-serif`,
                  fontSize: isGivenchy ? "10px" : descriptionStyles.fontSize,
                }}
              >
                {t("popupText")}
              </Typography>
              <div
                className="popper-triangle"
                style={{
                  borderTop: `10px solid ${descriptionStyles.color}`,
                }}
              />
            </Paper>
          </ClickAwayListener>
        </Popper>
      </div>
    </>
  );
};

export default QrcodeDesktop;
